var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVectorContactUs = function SvgVectorContactUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 308,
    height: 41,
    fill: "none",
    viewBox: "0 0 378 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vectorContactUs_svg__a)",
    d: "M200.103 40.44H.773V29.85h205.02c15.16 0 22.2 2.41 22.2-9.85v.55c0 15.4-12.49 19.89-27.89 19.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vectorContactUs_svg__b)",
    d: "M247.571 0h130.43v7.85h-136.34c-10.99 0-13.77 8.79-13.77 14.87v-3.03c0-10.82 8.86-19.68 19.68-19.68z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vectorContactUs_svg__a",
    x1: -432.959,
    x2: -67.666,
    y1: 40.44,
    y2: 356.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#280707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711211"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vectorContactUs_svg__b",
    x1: 241.778,
    x2: 546.924,
    y1: 22.72,
    y2: 158.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#280707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711211"
  })))));
};
export default SvgVectorContactUs;